import axios from "axios";
import Cookies from "js-cookie";
import { NIGHT_EYE_API_URL } from "../Process";
import { handleDepartmentLogOut } from "../HelperMethods";
// import store from "../Redux/Store";
// import { handleLogout } from "../Redux/Slices/ProjectSlice";

const axiosInstance = axios.create({
    baseURL: NIGHT_EYE_API_URL,
    headers: { "Content-Type": "application/json" },
});

axiosInstance.interceptors.request.use((config) => {
    const token = Cookies.get("NIGHT_EYE_JWT_TOKEN");
    const userID = Cookies.get("NIGHT_EYE_USER_ID");
    const userTokenUniqueID = Cookies.get("NIGHT_EYE_USER_TOKEN_UNIQUE_ID");
    // const currentlogintype = Cookies.get("UTT_JWT_TOKEN");  
    if (token) config.headers["Authorization"] = `Bearer ${token}`;
    if (userID) config.headers["userid"] = userID;
    if(userTokenUniqueID) config.headers["usertokenuniqueid"]=userTokenUniqueID
    config.headers["currentlogintype"] = "web";
    return config;
});

// axiosInstance.interceptors.response.use(
//     (res) => {
//         if (res?.data?.tokenStatus === false) {
//             console.log(res?.data, "tokenStatustokenStatus");
//             // store.dispatch(handleLogout()); // 👈 directly dispatch
//         }
//         return res;
//     },
//     (err) => {
//         console.log(err, "errerrerrerr")
//         if (err.response?.data?.tokenStatus === false) {
//             // store.dispatch(handleLogout());
//         }
//         return Promise.reject(err);
//     }
// );
axiosInstance.interceptors.response.use(
  (res) => {
    console.log(res,"resresresresresres")
    if (res?.tokenStatus === false) {
    //   store.dispatch(handleLogout());
    handleDepartmentLogOut()
      window.location.href = "/DepartmentLogin";
    
    }
    return res;
  },
  (err) => {
    if (err.response?.status === 401 || err.response?.status === 403) {
     handleDepartmentLogOut()
     window.location.href = "/DepartmentLogin";
    }
    return Promise.reject(err);
  }
);

export default axiosInstance;
